import { combineReducers, compose, createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import persistState from 'redux-localstorage'

import history from '../services/History'
import citiesReducer from './cities'
import layersReducer from './layers'
import newsReducer from './news'
import publicationsReducer from './publications'
import DownloadsReducer from './downloads'
import settingsReducer from './settings'
import usersReducer from './users'

const routerHistoryMiddleware = routerMiddleware(history)

let composer = compose
const middlewares = [
  thunkMiddleware,
  routerHistoryMiddleware
]

if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger')
  const { composeWithDevTools } = require('redux-devtools-extension')

  middlewares.push(logger)
  composer = composeWithDevTools
}

const reducers = combineReducers({
  routing: routerReducer,
  cities: citiesReducer,
  layers: layersReducer,
  news: newsReducer,
  publications: publicationsReducer,
  downloads: DownloadsReducer,
  settings: settingsReducer,
  users: usersReducer
})

const configureStore = initialState =>
  createStore(
    reducers,
    initialState,
    composer(
      applyMiddleware(...middlewares),
      persistState(['settings', 'users'])
    )
  )

export default configureStore



// WEBPACK FOOTER //
// ./src/reducers/configureStore.js